module.exports = __webpack_public_path__ + "static/media/TheMostEyeOpening.8aa40617.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/components/Motivation/TheMostEyeOpening/TheMostEyeOpening.mp4
// module id = 399
// module chunks = 0